// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Modal_modalOverlay__6GnaJ {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: var(--color-dim);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  animation: Modal_fadeIn__zuilp var(--animation-duration-default) var(--cubic-bezier-default);
}

.Modal_modalContent__JODE3 {
  background-color: var(--color-surface-light);
  border-radius: var(--radius-default);
  box-shadow: var(--shadow-large);
  display: flex;
  flex-direction: column;
  max-height: 90vh;
  animation: Modal_slideIn__9hxx8 var(--animation-duration-default) var(--cubic-bezier-default);
  position: relative;
}
.Modal_modalContent__JODE3.Modal_size-small__t0au\\+ {
  width: 400px;
}
.Modal_modalContent__JODE3.Modal_size-medium__Ggelg {
  width: 600px;
}
.Modal_modalContent__JODE3.Modal_size-large__j3o4K {
  width: 800px;
}
@media (max-width: 960px) {
  .Modal_modalContent__JODE3 {
    width: 90% !important;
    max-height: 80vh;
  }
}

.Modal_modalHeader__eJ-ri {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: var(--gutter) calc(var(--gutter) * var(--golden-ratio));
  border-bottom: 1px solid var(--color-border);
}

.Modal_modalTitle__YzazS {
  margin: 0;
  font-size: var(--font-size-large);
  font-weight: 600;
  color: var(--color-text);
}

.Modal_closeButton__3V9B- {
  background: transparent;
  border: none;
  cursor: pointer;
  font-size: 1.5rem;
  line-height: 1;
  color: var(--color-text-lighter);
  transition: color var(--animation-duration-fast) var(--cubic-bezier-default);
}
.Modal_closeButton__3V9B-:hover {
  color: var(--color-text);
}

.Modal_modalBody__esMbS {
  padding: calc(var(--gutter) * var(--golden-ratio));
  overflow-y: auto;
  flex: 1 1;
}

.Modal_modalFooter__2wrUh {
  padding: var(--gutter) calc(var(--gutter) * var(--golden-ratio));
  border-top: 1px solid var(--color-border);
  display: flex;
  justify-content: flex-end;
}

.Modal_modalActions__0qxpC {
  display: flex;
  gap: 0.75rem;
  justify-content: flex-end;
}

@keyframes Modal_fadeIn__zuilp {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes Modal_slideIn__9hxx8 {
  from {
    transform: translateY(10px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Modal/Modal.module.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,kCAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,4FAAA;AACF;;AAEA;EACE,4CAAA;EACA,oCAAA;EACA,+BAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,6FAAA;EACA,kBAAA;AACF;AACE;EACE,YAAA;AACJ;AAEE;EACE,YAAA;AAAJ;AAGE;EACE,YAAA;AADJ;AAIE;EAtBF;IAuBI,qBAAA;IACA,gBAAA;EADF;AACF;;AAIA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,gEAAA;EACA,4CAAA;AADF;;AAIA;EACE,SAAA;EACA,iCAAA;EACA,gBAAA;EACA,wBAAA;AADF;;AAIA;EACE,uBAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,gCAAA;EACA,4EAAA;AADF;AAGE;EACE,wBAAA;AADJ;;AAKA;EACE,kDAAA;EACA,gBAAA;EACA,SAAA;AAFF;;AAKA;EACE,gEAAA;EACA,yCAAA;EACA,aAAA;EACA,yBAAA;AAFF;;AAKA;EACE,aAAA;EACA,YAAA;EACA,yBAAA;AAFF;;AAKA;EACE;IACE,UAAA;EAFF;EAIA;IACE,UAAA;EAFF;AACF;AAKA;EACE;IACE,2BAAA;IACA,UAAA;EAHF;EAKA;IACE,wBAAA;IACA,UAAA;EAHF;AACF","sourcesContent":[".modalOverlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: var(--color-dim);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n  animation: fadeIn var(--animation-duration-default) var(--cubic-bezier-default);\n}\n\n.modalContent {\n  background-color: var(--color-surface-light);\n  border-radius: var(--radius-default);\n  box-shadow: var(--shadow-large);\n  display: flex;\n  flex-direction: column;\n  max-height: 90vh;\n  animation: slideIn var(--animation-duration-default) var(--cubic-bezier-default);\n  position: relative;\n  \n  &.size-small {\n    width: 400px;\n  }\n  \n  &.size-medium {\n    width: 600px;\n  }\n  \n  &.size-large {\n    width: 800px;\n  }\n\n  @media (max-width: 960px) {\n    width: 90% !important;\n    max-height: 80vh;\n  }\n}\n\n.modalHeader {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: var(--gutter) calc(var(--gutter) * var(--golden-ratio));\n  border-bottom: 1px solid var(--color-border);\n}\n\n.modalTitle {\n  margin: 0;\n  font-size: var(--font-size-large);\n  font-weight: 600;\n  color: var(--color-text);\n}\n\n.closeButton {\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  font-size: 1.5rem;\n  line-height: 1;\n  color: var(--color-text-lighter);\n  transition: color var(--animation-duration-fast) var(--cubic-bezier-default);\n  \n  &:hover {\n    color: var(--color-text);\n  }\n}\n\n.modalBody {\n  padding: calc(var(--gutter) * var(--golden-ratio));\n  overflow-y: auto;\n  flex: 1;\n}\n\n.modalFooter {\n  padding: var(--gutter) calc(var(--gutter) * var(--golden-ratio));\n  border-top: 1px solid var(--color-border);\n  display: flex;\n  justify-content: flex-end;\n}\n\n.modalActions {\n  display: flex;\n  gap: 0.75rem;\n  justify-content: flex-end;\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n@keyframes slideIn {\n  from {\n    transform: translateY(10px);\n    opacity: 0;\n  }\n  to {\n    transform: translateY(0);\n    opacity: 1;\n  }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modalOverlay": `Modal_modalOverlay__6GnaJ`,
	"fadeIn": `Modal_fadeIn__zuilp`,
	"modalContent": `Modal_modalContent__JODE3`,
	"slideIn": `Modal_slideIn__9hxx8`,
	"size-small": `Modal_size-small__t0au+`,
	"size-medium": `Modal_size-medium__Ggelg`,
	"size-large": `Modal_size-large__j3o4K`,
	"modalHeader": `Modal_modalHeader__eJ-ri`,
	"modalTitle": `Modal_modalTitle__YzazS`,
	"closeButton": `Modal_closeButton__3V9B-`,
	"modalBody": `Modal_modalBody__esMbS`,
	"modalFooter": `Modal_modalFooter__2wrUh`,
	"modalActions": `Modal_modalActions__0qxpC`
};
export default ___CSS_LOADER_EXPORT___;
